<template>
  <main class="content">
    <section class="main-section">
      <article class="main-section__content">
        <div class="primary-color sign-up-title">Forgot password</div>
        <div v-if="!submitted" xs12>
          <div class="title-description mb-50 pl-0">
            Please enter an e-mail address associated with your existing account. An e-mail
            containing password recovery link will be sent to the e-mail address you provided.
          </div>
          <forgot-password-form :initial-values="{}" :vs="$v" @values="form = $event" />
          <main-button text="Submit" depressed @click="submitForm" />
        </div>
        <v-flex v-else>
          <div class="title-description">Email sent!</div>
        </v-flex>
      </article>
    </section>
    <simple-snackbar v-bind.sync="snackbar" />
  </main>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

import { SEND_PW_RECOVERY_TOKEN } from '../../graphql/utils.graphql'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar'
import ForgotPasswordForm from './forgot-password-form.vue'
import MainButton from './../shared/main-button'
import { submitGuard } from './../../utils'

export default {
  name: 'forgot-password-container',
  components: {
    ForgotPasswordForm,
    MainButton,
    SimpleSnackbar,
  },
  data: () => ({
    snackbar: {},
    form: {},
    submitted: false,
  }),
  validations: {
    form: {
      email: { required, email },
    },
  },
  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { errors } = await this.$apollo.mutate({
          variables: this.form,
          mutation: SEND_PW_RECOVERY_TOKEN,
        })

        if (errors) {
          this.snackbar = {
            open: true,
            messageProp: errors[0].message,
            color: 'error',
          }
        } else {
          this.snackbar = {
            open: true,
            messageProp: 'Email sent',
            color: 'primary',
          }
          this.submitted = true
        }
      })
    },
  },
}
</script>

<style scoped>
.sign-up-title {
  font-family: Raleway, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 72px;
  line-height: 120%;
  letter-spacing: -0.03em;
  align-self: center;
  margin: 24px 0;
}

.mt-80 {
  margin-top: 80px;
}

.content {
  display: grid;
  grid-auto-rows: auto;
  gap: 13.125rem;
  margin-bottom: 13.125rem;
}

.main-section {
  max-width: 1216px;
  padding: 0 2.625rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 662px 1fr;
  gap: 2.625rem;
  align-items: center;
}

.main-section__content {
  margin: 2.625rem 0;
}
@media screen and (max-width: 670px) {
  .sign-up-title {
    font-size: 3.938rem;
  }
  .main-section {
    grid-template-columns: 1fr;
    margin: 0;
    padding: 0;
  }
  .main-section {
    grid-template-columns: 1fr;
  }
}
</style>
